module.exports = __webpack_public_path__ + "img/tarifas.8ab593e0.png";